import { createAction } from 'redux-actions';
import { SelectedUpgradesWithType } from '../types';
import { SelectedUpgrade } from '../../IncludedBaggage/types';
import { ServiceMeta } from '../../../Checkout/store/selectedServices/actions';

export const CLEAR = 'CLEAR';
export const DIFFERENT_FOR_RETURN_FLIGHT = 'DIFFERENT_FOR_RETURN_FLIGHT';
export const REMOVE_SERVICES = 'REMOVE_SERVICES';
export const DISABLE = 'DISABLE';
export const SET_SERVICES = 'SET_SERVICES';
export const SET_BAGGAGE_TAB = 'SET_BAGGAGE_TAB';
export const SET_CURRENT_SLIDE = 'SET_CURRENT_SLIDE';
export const SET_ALL_SERVICES = 'SET_ALL_SERVICES';
export const BAGGAGE_SAVE_SERVICES = 'BAGGAGE_SAVE_SERVICES';

export type ClearAction = ReturnType<typeof clear>;
export const clear = createAction(CLEAR);

export type DifferentForReturnFlightAction = ReturnType<typeof differentForReturnFlight>;
export const differentForReturnFlight = createAction(DIFFERENT_FOR_RETURN_FLIGHT);

export type DisableAction = ReturnType<typeof disable>;
export const disable = createAction<boolean>(DISABLE);

export type SetServicesAction = ReturnType<typeof setServices>;
export const setServices = createAction<SelectedUpgradesWithType>(SET_SERVICES);

export type SetBaggageTabAction = ReturnType<typeof setBaggageTab>;
export const setBaggageTab = createAction<string>(SET_BAGGAGE_TAB);

export type SetCurrentSlideAction = ReturnType<typeof setCurrentSlide>;
export const setCurrentSlide = createAction<number>(SET_CURRENT_SLIDE);

export type SetAllServicesAction = ReturnType<typeof setAllServices>;
export const setAllServices = createAction<SelectedUpgrade[]>(SET_ALL_SERVICES);

export type SaveServices = ReturnType<typeof saveServices>;
export const saveServices = createAction<{ meta?: ServiceMeta }>(BAGGAGE_SAVE_SERVICES);

export type ActionTypes =
	| ClearAction
	| DifferentForReturnFlightAction
	| SetServicesAction
	| DisableAction
	| SetCurrentSlideAction
	| SetAllServicesAction;
